<template>
    <mslPage :aIndex="1">
        <template v-slot:mslBody>
            <div class="pd_area">
                <!-- 产品详情 -->
                <div class="detail">
                    <div class="center m_center detail_center left_center">
                        <div class="left">
                            <!-- 轮播图 -->
                            <div class="swiper left_center">
                                <div class="datu" @mouseenter="enterFn" @mouseleave="leaveFn">
                                    <swiper ref="mySwiper" :options="swiperOptions">
                                        <swiper-slide class="row_center" v-for="(item, index) in detail.slider_image_list" :key="index">
                                            <div class="img_box">
                                                <img :src="item" alt="">
                                            </div>
                                        </swiper-slide>
                                        <div class="msl-prev row_center pointer hover_slowly leave_slowly" slot="button-prev">
                                            <span class="iconfont iconleft prev_icon"></span>
                                        </div>
                                        <div class="msl-next row_center pointer hover_slowly leave_slowly" slot="button-next">
                                            <span class="iconfont iconright next_icon"></span>
                                        </div>
                                    </swiper>
                                </div>
                            </div>
                        </div>
                        <div class="right">
                            <div class="title">{{ detail.store_name }}</div>
                            <div class="price left_center">
                                <div class="real_price">{{ '￥' + (detail.price || '--') }}</div>
                                <div class="d_price">{{ '￥' + (detail.ot_price || '--') }}</div>
                            </div>
                            <div class="intro">
                                {{ detail.store_info || '--' }}
                            </div>
<!--                            <div class="fenye column_center">-->
<!--                                <swiper ref="mySwiper" :options="swiperOptions.thumbs.swiper" class="gallery-thumbs">-->
<!--                                    <swiper-slide class="row_center" v-for="(item, index) in 6" :key="index">-->
<!--                                        <div class="img_box">-->
<!--                                            <img src="../assets/pc_pic/pro_detail/pd_1.png" alt="">-->
<!--                                        </div>-->
<!--                                    </swiper-slide>-->
<!--                                </swiper>-->
<!--                            </div>-->
                            <div class="e_code" v-if="detail.qr_code">
<!--                                <div class="qr_code"></div>-->
                                <img :src="detail.qr_code" alt="">
                                <div class="name ta_center">手机微信扫码购买</div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- 产品参数 -->
                <div class="pro_canshu r_position">
                    <img src="../assets/pc_pic/pro_detail/half_circle_2.png" alt="" class="a_position l_0 t_0 circle">
                    <!-- 标签 -->
                    <div class="tabs a_position t_0 l_0 w h" style="z-index: 90;">
                        <div class="center m_center tabs_center space_center">
                            <div class="item column_center">
                                <span class="iconfont iconicon_jiaoyi icon"></span>
                                <span class="name ta_center">铝 + </span>
                                <span class="name ta_center mt_0">不锈钢外壳</span>
                            </div>
                            <div class="item column_center">
                                <span class="iconfont iconicon_fuwu icon"></span>
                                <span class="name ta_center">无需用电</span>
                                <span class="name ta_center mt_0">更加环保安全</span>
                            </div>
                            <div class="item column_center">
                                <span class="iconfont iconicon_xinxi icon"></span>
                                <span class="name ta_center">全封闭</span>
                                <span class="name ta_center mt_0">防止二次污染</span>
                            </div>
                            <div class="item column_center">
                                <span class="iconfont iconicon_shuju icon"></span>
                                <span class="name ta_center">精密制造，体积少，更有利于更具吸引力的安装和维护</span>
                            </div>
                        </div>
                    </div>
<!--                    <div class="center m_center pc_center">-->
<!--                        <div class="header">-->
<!--                            <div class="title">产品参数</div>-->
<!--                            <div class="line"></div>-->
<!--                        </div>-->
<!--                        <div class="h_area space_center">-->
<!--                            <div class="h_item">-->
<!--                                <div class="h_title">型号</div>-->
<!--                                <div class="h_intro">OSS-100-200（20）</div>-->
<!--                            </div>-->
<!--                            <div class="h_item">-->
<!--                                <div class="h_title">型号</div>-->
<!--                                <div class="h_intro">OSS-100-200（20）</div>-->
<!--                            </div>-->
<!--                            <div class="h_item">-->
<!--                                <div class="h_title">型号</div>-->
<!--                                <div class="h_intro">OSS-100-200（20）</div>-->
<!--                            </div>-->
<!--                            <div class="h_item">-->
<!--                                <div class="h_title">型号</div>-->
<!--                                <div class="h_intro">OSS-100-200（20）</div>-->
<!--                            </div>-->
<!--                            <div class="h_item">-->
<!--                                <div class="h_title">型号</div>-->
<!--                                <div class="h_intro">OSS-100-200（20）</div>-->
<!--                            </div>-->
<!--                        </div>-->
<!--                    </div>-->
                </div>
                <!-- 具体详情 -->
                <div class="juti" v-if="detail.description">
                    <div class="center m_center juti_center">
                        <transition name="fade">
                            <div class="list" v-html="detail.description">
<!--                                <div class="item space_center">-->
<!--                                    <div class="i_left">-->
<!--                                        <img src="../assets/pc_pic/pro_detail/pd_water_2.png" alt="">-->
<!--                                    </div>-->
<!--                                    <div class="i_right">-->
<!--                                        害细菌，病毒去除率99.99％。-->
<!--                                    </div>-->
<!--                                </div>-->
<!--                                <div class="item space_center">-->
<!--                                    <div class="i_right">-->
<!--                                        害细菌，病毒去除率99.99％。-->
<!--                                    </div>-->
<!--                                    <div class="i_left border_r">-->
<!--                                        <img src="../assets/pc_pic/pro_detail/pd_water_1.png" alt="">-->
<!--                                    </div>-->
<!--                                </div>-->
<!--                                <div class="item space_center">-->
<!--                                    <div class="i_left">-->
<!--                                        <img src="../assets/pc_pic/pro_detail/pd_water_3.png" alt="">-->
<!--                                    </div>-->
<!--                                    <div class="i_right">-->
<!--                                        害细菌，病毒去除率99.99％。-->
<!--                                    </div>-->
<!--                                </div>-->
<!--                                <div class="item space_center">-->
<!--                                    <div class="i_right">-->
<!--                                        害细菌，病毒去除率99.99％。-->
<!--                                    </div>-->
<!--                                    <div class="i_left border_r">-->
<!--                                        <img src="../assets/pc_pic/pro_detail/pd_water_4.png" alt="">-->
<!--                                    </div>-->
<!--                                </div>-->
<!--                                <div class="item space_center">-->
<!--                                    <div class="i_left">-->
<!--                                        <img src="../assets/pc_pic/pro_detail/pd_water_5.png" alt="">-->
<!--                                    </div>-->
<!--                                    <div class="i_right">-->
<!--                                        害细菌，病毒去除率99.99％。-->
<!--                                    </div>-->
<!--                                </div>-->
                            </div>
<!--                            <div style="height: 200px; width: 100%; background-color:#fff;" v-else></div>-->
                        </transition>
                    </div>
                </div>
                <!-- 热门产品 -->
                <hotProduction :isIndex="false"></hotProduction>
            </div>
        </template>
    </mslPage>
</template>

<script>
    import hotProduction from '../components/hot_production'
    import { Swiper as SwiperClass, Pagination, Mousewheel, Autoplay, Navigation ,EffectFade,EffectCoverflow, Thumbs } from 'swiper/core'
    SwiperClass.use([Pagination, Mousewheel, Autoplay,Navigation,EffectFade,EffectCoverflow, Thumbs])
    import 'swiper/swiper-bundle.min.css'
    import { proDetail } from "../api/common";
    export default {
        name: "production_detail",
        components: {
            hotProduction
        },
        data() {
            return {
                id: null,
                detail: {},
                isEnter: false,
                swiperOptions: {
                    loop: true,
                    autoplay: {
                        delay: 3000, // 自动切换的时间间隔（单位ms）
                        disableOnInteraction: false,  // 用户操作swiper之后，是否禁止autoplay
                    },
                    navigation: {
                        nextEl: ".msl-next",
                        prevEl: ".msl-prev",
                    },
                    //滑动速度
                    speed: 1000,
                    // thumbs: {
                    //     swiper: {
                    //         el: '.gallery-thumbs',
                    //         loop: true,
                    //         // direction: 'vertical',
                    //         // autoplay: {
                    //         //     delay: 3000, // 自动切换的时间间隔（单位ms）
                    //         //     disableOnInteraction: true,  // 用户操作swiper之后，是否禁止autoplay
                    //         // },
                    //         //滑动速度
                    //         // speed: 1000,
                    //         spaceBetween: 10,
                    //         slidesPerView: 5,
                    //         freeMode: true, // 滑动多少就是多少
                    //         loopedSlides: 5, //looped slides should be the same
                    //         watchSlidesVisibility: true,
                    //         watchSlidesProgress: true,
                    //     }
                    // }
                },
                swiperArr: [
                    {
                        img: '../assets/pc_pic/index/pro_1.png'
                    },
                    {
                        img: '../assets/pc_pic/index/pro_2.png'
                    },
                    {
                        img: '../assets/pc_pic/index/pro_3.png'
                    }
                ],
                scroll: 0,
                show1: false,
            }
        },

        mounted() {
            window.addEventListener('scroll',this.handleScroll);
            this.getParams();
            // console.log(this.b, 'b');
            // this.swiperOptions['thumbs']['swiper'] = this.thumbs;
        },
        computed: {
            swiper() {
                return this.$refs.mySwiper.$swiper
            },
        },
        methods: {
            getParams(){
                this.id = this.$route.query.id; // 取到路由带过来的参数
                this.getDetail();
                window.scrollTo(0, 0);//回到顶部
            },
            // 商品详情
            getDetail() {
                try {
                    console.log('测试1');
                    proDetail({
                        id: this.id
                    }).then((res) => {
                        if (res.code == 1) {
                            if (res.data && res.data.id) {
                                this.detail = res.data;
                                console.log(this.detail, 'detail');
                            }
                        }
                    })
                } catch {
                    console.log('测试2');
                    this.$message.error('获取数据失败，请刷新');
                }
            },
            handleScroll(){
                this.scroll = document.documentElement.scrollTop||document.body.scrollTop;
                if (this.scroll >= 1100 && this.scroll <= 1300) this.show1 = true;
            },
            enterFn () {
                this.swiper.autoplay.stop()
                this.isEnter = true;
            },
            leaveFn () {
                this.swiper.autoplay.start()
                this.isEnter = false;
            }
        }
    }
</script>

<style scoped lang="scss">
    .fade-enter-active, .fade-leave-active {
        transition: opacity 3.5s;
    }
    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
        opacity: 0;
    }
    .pd_area {
        width: 100%;
        .detail {
            width: 100%;
            padding-top: 60px;
            .detail_center {
                padding: 80px 0;
                box-sizing: border-box;
                .left {
                    .swiper-container {
                        width: 616px;
                        height: 616px;
                        .img_box {
                            width: 100%;
                            height: 100%;
                            img {
                                width: 100%;
                                height: 100%;
                            }
                        }
                    }
                    .msl-prev {
                        width: 42px;
                        height: 42px;
                        background: #BFBFBF;
                        border-radius: 2px;
                        position: absolute;
                        top: 50%;
                        left: 0;
                        z-index: 30;
                        margin-top: 21px;
                        .prev_icon {
                            font-size: 18px;
                            color: #fff;
                        }
                        &:hover {
                            background: #262626;
                            .prev_icon, .next_icon {
                            }
                        }
                    }
                    .msl-next {
                        width: 42px;
                        height: 42px;
                        background: #BFBFBF;
                        border-radius: 2px;
                        position: absolute;
                        top: 50%;
                        right: 0;
                        z-index: 30;
                        margin-top: 21px;
                        .next_icon {
                            font-size: 18px;
                            color: #fff;
                        }
                        &:hover {
                            background: #262626;
                            .next_icon, .next_icon {
                            }
                        }
                    }
                    .swiper {
                        .datu {
                            margin-left: 32px;
                            img {
                                width: 616px;
                                height: 616px;
                            }
                        }
                    }
                }
                .right {
                    margin-left: 48px;
                    .title {
                        font-size: 30px;
                        font-weight: bold;
                        line-height: 38px;
                        color: #262626;
                    }
                    .price {
                        margin-top: 12px;
                        .real_price {
                            font-size: 20px;
                            font-weight: bold;
                            line-height: 30px;
                            color: #262626;
                        }
                        .d_price {
                            font-size: 16px;
                            font-weight: 400;
                            line-height: 30px;
                            color: #8C8C8C;
                            text-decoration: line-through;
                            margin-left: 8px;
                        }
                    }
                    .intro {
                        margin-top: 12px;
                        font-size: 16px;
                        font-weight: 400;
                        line-height: 24px;
                        color: #8C8C8C;
                    }
                    .fenye {
                        margin-top: 24px;
                        width: 600px;
                        height: 100px;
                        .swiper-container {
                            width: 600px;
                            height: 200px;
                            img {
                                width: 100%;
                                height: 100%;
                            }
                            .swiper-slide {
                                opacity: 0.4;
                            }
                            /*.swiper-slide-active {*/
                            /*    opacity: 1;*/
                            /*}*/
                            .swiper-slide-thumb-active {
                                opacity: 1;
                            }
                        }
                    }
                    .e_code {
                        width: 128px;
                        margin-top: 40px;
                        .qr_code {
                            width: 160px;
                            height: 160px;
                            background-color: pink;
                        }
                        img {
                            width: 160px;
                            height: 160px;
                        }
                        .name {
                            width: 160px;
                            font-size: 16px;
                            font-weight: 400;
                            line-height: 18px;
                            color: #8C8C8C;
                            margin-top: 12px;
                        }
                    }
                }
            }
        }

        .pro_canshu {
            background-color: #fafafa;
            padding: 64px 0;
            height: 240px;
            box-sizing: border-box;
            .tabs {
                width: 100%;
                height: 240px;
                box-sizing: border-box;
                .tabs_center {
                    height: 240px;
                }
                .item {
                    width: 270px;
                    margin-right: 48px;
                    &:last-child {
                        margin-right: 0px;
                    }
                    .icon {
                        font-size: 46px;
                        color: #262626;
                    }
                    .name {
                        margin-top: 20px;
                        font-size: 16px;
                        font-weight: 400;
                        line-height: 24px;
                        color: #262626;
                    }
                    .mt_0 {
                        margin-top: 2px;
                    }
                }
            }

            .circle {
                width: 152px;
                height: 152px;
            }
            .header {
                .title {
                    font-size: 30px;
                    font-weight: bold;
                    line-height: 38px;
                    color: #fff;
                }
                .line {
                    width: 20px;
                    height: 2px;
                    background: #fff;
                    opacity: 1;
                    margin-top: 20px;
                }
            }
            .h_area {
                margin-top: 80px;
                .h_item {
                    width: 173px;
                    .h_title {
                        font-size: 16px;
                        font-weight: 400;
                        line-height: 24px;
                        color: #FFFFFF;
                        opacity: 0.8;
                    }
                    .h_intro {
                        margin-top: 8px;
                        font-size: 16px;
                        font-weight: bold;
                        line-height: 24px;
                        color: #FFFFFF;
                    }
                }
            }

        }
        .juti {
            .juti_center {
                padding: 128px 0;
                .list {
                    width: 100%;
                    &::v-deep {
                        p {
                            width: 100%!important;
                            img {
                                width: 100%!important;
                            }
                        }
                    }
                    .item {
                        width: 100%;
                        margin-top: 128px;


                        .border_r {
                            border-radius: 70px 70px 70px 0!important;
                        }
                        .i_left {
                            width: 527px;
                            height: 396px;
                            border-radius: 70px 70px 0 70px;
                            overflow: hidden;
                            img {
                                width: 100%;
                                height: 100%;
                            }
                        }
                        .i_right {
                            width: 512px;
                            font-size: 38px;
                            font-weight: 400;
                            line-height: 57px;
                            color: #262626;
                        }
                    }
                }
            }
        }
    }
</style>
